export default __webpack_public_path__ + "static/media/reduxback.617e062d.svg";